import * as runtime from "@baseline/runtime";
import { Context, Registry } from "@baseline/runtime";
import { UIManager } from "@baseline/ui/apps";
import { RoutingService } from "../routing";
import { Page } from "./ui";
import { Config, ConfigurationService } from "../config";
import { CardService } from "./services";
import { GraphQL } from "./internal-api";
import { InternalTransactionsApiClient } from "./internal-api";
import { Environment } from "./environment";
import { AdyenEnvironmentForHostEnvironment, CardBrandRepresentationForAdyenCode, InternalAdyenSessionsApiClient } from "./adyen";
import { InternalTokenApiClient } from "./internal-api/token-client";


export class App extends runtime.App {
    constructor() {
        super();
        this.update = this.update.bind(this);
    }

    start(): void {
        this.context = this.load();

        // Start after auth to route correctly on application boot
        const routingService = this.context.require(RoutingService);
        routingService.start();

        // Start UI
        const uiManager = this.context.require(UIManager);
        uiManager.start();
    }

    protected override load(options?: { registry?: Registry; context?: Context; }): Context {
        let { registry, context } = options ?? {};

        registry = registry ?? runtime.Registry.create();
        context = context ?? runtime.Context.create({ registry });

        registry.set(App, this);

        // Configuration
        const config = Config.load();
        registry.add(new ConfigurationService(config));

        registry.set(RoutingService, new RoutingService(context));
        registry.set(UIManager, new UIManager(context, { component: Page }));
        registry.set(InternalTokenApiClient, new InternalTokenApiClient(config.internalApiOrigin));
        registry.add(new CardService(context, {
            provider: {
                name: config.cardProcessor.provider.name,
                options: {
                    // todo: is this correct? How do I use the registry api to set nested instance options?
                    ...config.cardProcessor.provider.options,
                    adyenEnvironment: AdyenEnvironmentForHostEnvironment[Environment.fromStr(config.environment)],
                    cardBrandRepresentationForAdyenCode: CardBrandRepresentationForAdyenCode,
                }
            }
        }));


        return context;
    }

    private update(): void {
        this.onUpdate();
    };

    private onUpdate(): void {
        this.emit("update", this);
    }
}
